var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFaviconPhp = function SvgFaviconPhp(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68059 11.1356L8.86209 4.22148L10.9749 7.46226L12.9913 4.22148L15.093 7.6964H15.3782C15.4457 7.31769 15.487 6.92786 15.487 6.52846C15.487 2.92267 12.5643 0 8.95853 0C5.35274 0 2.42871 2.92267 2.42871 6.52846C2.42871 8.32724 3.15593 9.9552 4.33215 11.1356H4.68059Z",
    fill: "#A71930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85058 5.77124L10.3009 8.22147L4.41703 18.4273H11.9619L13.4618 21.0387H0L8.85058 5.77124Z",
    fill: "#A71930"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23717 17.4277H6.23877L12.9449 5.73853L21.7955 21.0707L18.9431 21.1187L13.0261 10.8977L9.23717 17.4277Z",
    fill: "#A71930"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.283 22.0224L11.494 15.4774L13.0105 12.866L19.7648 24.5374H2.11182L3.51392 21.9893L15.283 22.0224Z",
    fill: "#A71930"
  })));
};
export { SvgFaviconPhp as ReactComponent };
export default __webpack_public_path__ + "static/media/favicon-php.4e225116.svg";